import { breakpoints, colors } from '@web-for-marketing/react-ui';

export const fourColumnImagesStyle = {
    titles: {
        color: colors.core.geotab,
        textAlign: 'center',
        maxWidth: '72rem',
        margin: '0 auto 3rem',
    },
    profileNames: {
        color: colors.core.geotab,
    },
    gridContainer: {
        marginTop: '2rem',
        marginBottom: '2rem',
    },
    cardButtonWrapper: {
        padding: 0,
        textAlign: 'left',
    },
    linkContainer: {
        height: '100%',
        width: '100%',
    },
    linkText: {
        color: colors.text.activePrimary,
    },
    cardContainer: {
        minWidth: 200,
        padding: '2.7rem 0',
        boxSizing: 'border-box',
        [`@media (max-width: ${breakpoints.md})`]: {
            padding: 0,
            maxWidth: '45rem',
            marginBottom: '3rem',
            margin: 'auto',
        },
    },
    contentContainer: {
        padding: '2rem',
    },
    media: {
        height: 'auto',
        width: '100%',
        marginBottom: '3rem',
        objectFit: 'cover',
        [`@media (max-width: ${breakpoints.md})`]: {
            marginBottom: 0,
        },
    },
    profileMedia: {
        maxHeight: '20rem',
        margin: 'auto',
    },
} as const;
